module.exports = __webpack_public_path__ + "media/images/payment_methods/creditcard-016cd1bb702083528bc12bc756e7f709.svg";